import { render } from "./moment.vue?vue&type=template&id=c06a6292&scoped=true"
import script from "./moment.vue?vue&type=script&lang=js"
export * from "./moment.vue?vue&type=script&lang=js"

import "./moment.vue?vue&type=style&index=0&id=c06a6292&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c06a6292"]])

export default __exports__